import { render } from "./Api.vue?vue&type=template&id=3e884cad&bindings={\"openapiSpecificationUrl\":\"data\"}"
import script from "./Api.vue?vue&type=script&lang=js"
export * from "./Api.vue?vue&type=script&lang=js"
script.render = render

export default script